module.exports = __webpack_public_path__ + "static/media/YF14_1.b367d1df.jpg";